<template>
  <div class="page-content">
    <div class="settings-layout">
      <aside class="sidebar">
        <ul>
          <li
            v-for="item in menu"
            :key="item.id"
            :class="{ active: activeTab === item.id }"
            @click="activeTab = item.id"
          >
            {{ item.label }}
          </li>
        </ul>
      </aside>

      <section class="content">
        <component :is="activeComponent" />
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { getUser } from '@/utils/auth'

import Profile from './SettingsSections/Profile.vue'
import Security from './SettingsSections/Security.vue'
import Notifications from './SettingsSections/Notifications.vue'
import DeleteAccount from './SettingsSections/DeleteAccount.vue'
import Languages from './SettingsSections/Languages.vue'
import Certificates from './SettingsSections/Certificates.vue'

const user = getUser()
const isTranslator = user?.role === 'translator'
const activeTab = ref('profile')

const menu = [
  { id: 'profile', label: 'Profil' },
  { id: 'security', label: 'Güvenlik' },
  { id: 'notifications', label: 'Bildirimler' },
  ...(isTranslator ? [
    { id: 'languages', label: 'Dillerim' },
    { id: 'certificates', label: 'Sertifikalarım' }
  ] : []),
  { id: 'delete', label: 'Hesap Silme' }
]

const activeComponent = computed(() => {
  switch (activeTab.value) {
    case 'profile': return Profile
    case 'security': return Security
    case 'notifications': return Notifications
    case 'languages': return Languages
    case 'certificates': return Certificates
    case 'delete': return DeleteAccount
    default: return Profile
  }
})
</script>

<style scoped>
.settings-layout {
  display: flex;
  max-width: 1100px;
  margin: 100px auto; /* Yalnızca üstten boşluk */
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0,0,0,0.05);
  overflow: hidden;
  min-height: 500px;
}

.sidebar {
  width: 220px;
  background: #f4f4f4;
  padding: 20px;
  border-right: 1px solid #ddd;
}

.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar li {
  padding: 12px;
  margin-bottom: 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.3s;
}
.page-content {
  min-height: calc(100vh - 200px); /* yaklaşık header+footer yüksekliği kadar düş */
}
.sidebar li:hover {
  background-color: #ddd;
}

.sidebar li.active {
  background-color: #2980b9;
  color: white;
  font-weight: bold;
}

.content {
  flex: 1;
  padding: 30px;
}
/* === Mobil uyumluluk === */
@media (max-width: 768px) {
  .settings-layout {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #ddd;
    padding: 10px;
    background-color: #f4f4f4;
  }

  .sidebar ul {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    justify-content: center;
  }

  .sidebar li {
    flex: 1 1 auto;
    text-align: center;
    padding: 10px 12px;
    font-size: 14px;
    margin: 0;
    white-space: nowrap;
  }

  .content {
    padding: 20px 10px;
  }
}
</style>
